import styled from '@emotion/styled';

export default styled('div')`
  background-color: #e6f7ff;
  height: 24px;
  z-index: 0;
  width: 24px;
  color: white;
  position: absolute;
  border-radius: 2px;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;
  outline: 5px solid #e6f7ff;
`;
